
    <button mat-raised-button color="primary" (click)="openDialog()">Add a new activity</button>

